// Pure helpers for the Export tab's selection-scoped form. Mirrors the Scan tab's selection rules
// (HOVTab.js: click toggles, shift-click selects the range from the last click, select-all toggles).

export const MIXED = 'mixed';

// A tile's identity must survive new files being added (list indexes shift): URL, never position.
export const keyOf = (entry) => entry.url || entry.localUrl;

// Shared value of `field` across `metas`: { mixed:false, value } when all agree, { mixed:true } when they differ.
export function sharedValue(metas, field) {
  if (!metas.length) return { mixed: false, value: undefined };
  const first = metas[0][field];
  for (let i = 1; i < metas.length; i++) if (metas[i][field] !== first) return { mixed: true, value: undefined };
  return { mixed: false, value: first };
}

// Shift-click: every key between the anchor and the target (inclusive), in grid order. Falls back to a toggle.
export function rangeKeys(orderedKeys, anchor, target) {
  const a = orderedKeys.indexOf(anchor), b = orderedKeys.indexOf(target);
  if (a === -1 || b === -1) return null;
  return orderedKeys.slice(Math.min(a, b), Math.max(a, b) + 1);
}

// "select all" toggles: everything selected → unselect, otherwise select every key.
export function toggleAll(orderedKeys, selected) {
  return orderedKeys.every(k => selected.has(k)) ? new Set() : new Set(orderedKeys);
}

// One base name on a multi-selection: same base, numbered -1, -2, … in grid order.
export function autoNumber(selectedKeysInOrder, base) {
  const out = {};
  selectedKeysInOrder.forEach((k, i) => { out[k] = { creativeName: base.trim(), n: i + 1 }; });
  return out;
}

// Final names that appear more than once → their keys (a tile with a duplicate name is not ready).
export function duplicateKeys(nameByKey) {
  const seen = {}; const dup = new Set();
  Object.keys(nameByKey).forEach(k => { const n = nameByKey[k]; if (!n) return; (seen[n] = seen[n] || []).push(k); });
  Object.keys(seen).forEach(n => { if (seen[n].length > 1) seen[n].forEach(k => dup.add(k)); });
  return dup;
}

// 'ready' needs a creator and a creative name, and a name no other tile has.
export function tileStatus(meta, isDuplicate) {
  const missing = [];
  if (!meta || !(meta.creator || '').trim()) missing.push('creator');
  if (!meta || !(meta.creativeName || '').trim()) missing.push('name');
  if (isDuplicate) missing.push('duplicate name');
  return { ready: missing.length === 0, missing };
}

// More than `limit` variations of one concept (originals don't count). Concept = the source video a variation came from.
export function biggestConcept(entries, limit = 5) {
  const counts = {};
  entries.forEach(e => { if (e.isOriginal || e.isLocal || e.sourceQueueId == null) return; counts[e.sourceQueueId] = (counts[e.sourceQueueId] || 0) + 1; });
  const max = Object.values(counts).reduce((m, n) => Math.max(m, n), 0);
  return max > limit ? max : 0;
}
